<template>
  <div id="app">
    <!--<router-view/>-->
    <!--页面返回不刷新-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive&&routerState"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive&&routerState"></router-view>

  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
      return{
        reload:this.reload
      }
    },
    //声明变量
    data(){
      return{
        routerState:true
      }
    },
    methods:{
      //利用$nextTick特性，router跳转完成后展示页面
      reload(){
        this.routerState = false;
        this.$nextTick(()=>{
          this.routerState = true;
        })
      }
    }
}
</script>

<style >
*{
  margin: 0;
  padding: 0;
}
body {
  margin: 0px;
  padding: 0px;
  /*background: url(assets/bg1.jpg) center !important;
    background-size: cover;*/
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
::-webkit-scrollbar{ /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
}
::-webkit-scrollbar-thumb{ /*滚动条里面小方块*/
    border-radius: 10px;
    background: #cfcbcb;
}
::-webkit-scrollbar-track{ /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}
.el-menu {
  background-color: rgb(49, 65, 107)!important;
}
/* 更改进度条颜色 */
#nprogress .bar {
  background: #7dc955 !important;
  height: 2px !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue